import React, { useMemo } from "react";
import { Badge } from "react-bootstrap";

const TagsDisplay = ({ tags = [] }) => {
  const sortedTags = useMemo(() => [...(tags || [])].sort(), [tags]);

  if (!tags || tags.length === 0) {
    return null;
  }

  return (
    <div className="tags-display mb-2">
      {sortedTags.map((tag, index) => (
        <Badge
          key={index}
          pill
          className="me-3 mb-1"
          style={{ 
            backgroundColor: "#00008F", 
            color: "white",
            fontSize: "0.8em",
            padding: "0.4em 0.6em",
            marginRight: "0.2rem",
            marginBottom: "0.25rem"
          }}
        >
          {tag}
        </Badge>
      ))}
    </div>
  );
};

export default TagsDisplay;
